import React from "react";
import { Card } from "./ui/card";

/**
 * Wraps a single practice widget with a title, description and a bordered
 * testable region. Every widget uses this so learners see the same visual
 * pattern across levels.
 */
export default function PracticeSection({ id, title, blurb, hint, children }) {
  return (
    <section id={id} className="mb-8 scroll-mt-24" data-testid={`section-${id}`}>
      <div className="flex items-baseline gap-2 mb-1">
        <a href={`#${id}`} className="text-[10px] tag-mono text-zinc-400 hover:text-[#002FA7]" data-testid={`anchor-${id}`}>#</a>
        <h2 className="font-display text-xl font-bold tracking-tight text-zinc-950">{title}</h2>
      </div>
      {blurb && <p className="text-sm text-zinc-600 mb-3">{blurb}</p>}
      <Card className="p-5 bg-white">
        <div data-testid={`stage-${id}`}>{children}</div>
      </Card>
      {hint && (
        <p className="text-[11px] tag-mono text-zinc-500 mt-2">
          <span className="uppercase font-bold tracking-widest text-zinc-400 mr-1">tip</span>{hint}
        </p>
      )}
    </section>
  );
}
